import { render, staticRenderFns } from "./DiscountCreateAndUpdateFormItems.vue?vue&type=template&id=684eacb4&"
import script from "./DiscountCreateAndUpdateFormItems.vue?vue&type=script&lang=js&"
export * from "./DiscountCreateAndUpdateFormItems.vue?vue&type=script&lang=js&"
import style0 from "./DiscountCreateAndUpdateFormItems.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports